import { render, staticRenderFns } from "./CastCardShimmer.vue?vue&type=template&id=728baf8e&scoped=true&"
import script from "./CastCardShimmer.vue?vue&type=script&lang=js&"
export * from "./CastCardShimmer.vue?vue&type=script&lang=js&"
import style0 from "./CastCardShimmer.vue?vue&type=style&index=0&id=728baf8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728baf8e",
  null
  
)

export default component.exports